import Cookies from 'js-cookie';
import React, { useEffect, useRef, useState } from 'react';
import twMerge from 'twMerge';

import HeaderMenuColumn from 'components/Header/components/HeaderMenuColumn';
import HeaderSubMenu from 'components/Header/components/HeaderSubMenu';
import { menuContainerStyles } from 'components/Header/styles/HeaderMenu.styles';
import { handleMouseOver } from 'components/Header/utils/functions';

import type { ContentfulItemMenu } from 'graphqlTypes';
import type { Dispatch, FC } from 'react';

export interface HeaderMenuProps
  extends Omit<ContentfulItemMenu, 'children' | 'contentful_id' | 'id' | 'internal' | 'node_locale'> {
  index: number;
  hasSubMenu: boolean;
  menuActive: boolean;
  setActiveDropdownIndex: Dispatch<React.SetStateAction<number | null>>;
}

const HeaderMenu: FC<HeaderMenuProps> = ({
  index,
  label,
  links,
  menuButton,
  hasSubMenu,
  menuActive,
  setActiveDropdownIndex,
}) => {
  const isFirstRender = useRef(true);
  const [activeSubMenu, setActiveSubMenu] = useState<number | null>(0);

  useEffect(() => {
    if (activeSubMenu === null) {
      return;
    }

    if (Cookies.get('activeSubMenu') === undefined) {
      Cookies.set('activeSubMenu', activeSubMenu.toString());
    } else {
      setActiveSubMenu(parseInt(Cookies.get('activeSubMenu') as string));
    }
  }, []);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;

      return;
    }

    if (activeSubMenu === null) {
      return;
    }

    Cookies.set('activeSubMenu', activeSubMenu.toString());
  }, [activeSubMenu]);

  const subMenus = links?.filter(link => link?.__typename === 'ContentfulItemMenu');
  const subMenuStyles = label === 'Industries' ? 'min-h-[496px] h-[calc(100%+0.5px)]' : '';

  return (
    <div
      className={twMerge(menuContainerStyles({ hasSubMenu, menuActive }))}
      onMouseEnter={() => handleMouseOver(index, setActiveDropdownIndex)}
      onMouseLeave={() => setActiveDropdownIndex(null)}
    >
      <div className="-mt-px flex w-full pt-4">
        <HeaderMenuColumn
          links={links}
          label={label}
          menuButton={menuButton}
          activeSubMenu={activeSubMenu}
          setActiveSubMenu={setActiveSubMenu}
        />
        <div className="-ml-px h-full pt-6">
          <div className={`flex w-full bg-white pt-[16px] shadow-lg ${subMenuStyles}`}>
            {subMenus?.map((subMenu, idx) => {
              if (idx !== activeSubMenu || subMenu?.__typename !== 'ContentfulItemMenu') {
                return null;
              }

              const { links: subMenuColumn } = subMenu;

              return subMenuColumn?.map(column => {
                if (!column || column?.__typename !== 'ContentfulItemMenu') {
                  return null;
                }

                return <HeaderSubMenu key={column.id} {...column} />;
              });
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderMenu;
